import Auth0Lock from 'auth0-lock';
import config from 'config';

export default class AuthService {
  constructor(callback) {
    // Configure Auth0

    this.lock = new Auth0Lock(config.auth0.clientId, config.auth0.domain, {
      auth: {
        redirectUrl: `${config.cove.ui}/loggedin`,
        responseType: 'token',
      },

      closable: false,
      languageDictionary: {
        title: '',
      },
      theme: {
        logo: '/images/logo.svg',
      },
    });

    if (callback) {
      this.callback = callback;
    }

    // Hacky way of inserting TOS link into Auth0 login screen ¯\_(ツ)_/¯ YOLO
    this.lock.on('show', () => {
      const toslink = `
        <p class="login-tos">
          By logging in, you agree to our
          <br />
          <a href="${config.cove.toslink}" target="_blank">terms of use</a>
          &nbsp;and&nbsp;
          <a href="${config.cove.privacylink}" target="_blank">privacy policy</a>
        </p>`;
      document.querySelector('.auth0-lock-center').insertAdjacentHTML('beforeend', toslink);
      const el = document.querySelector('.login-tos')
      el.className += ' fade';
    });

    // Do stuff when the user logs in
    this.lock.on('authenticated', (...args) => {
      // Cleanup callback so we don't stack up
      this.callback(...args);
      this.callback = null;

      // Cleanup TOS link
      const el = document.querySelector('.login-tos');
      if(el) {
        el.className = 'login-tos';
      }
    });
  }

  showLogin() {
    // Call the show method to display the widget.
    this.lock.show();
  }

  hideLogin() {
    // Call the show method to display the widget.
    this.lock.hide();
  }

}

export const goAfterLogin = (path, guest = false) => {
  window.sessionStorage.setItem('goAfterLogin', path);
  if (guest) {
    window.sessionStorage.setItem('goAfterLoginAsGuest', guest);
  }
};



// WEBPACK FOOTER //
// ./web/utils/AuthService.js